import { Component, DestroyRef, inject, OnInit, Input } from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { StatusDTO } from 'src/app/shared/Models/Models';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import {
  Ca_State_prov,
  Us_State_prov,
  transformIntoApiCallObj,
} from 'src/app/gdo/gdo-shared/Models/Constants';
import { IAcctDetail } from 'src/app/gdo/gdo-shared/Models/Interfaces';
import { GdoStepCompletionStatusComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-step-completion-status/gdo-step-completion-status.component';

@Component({
  selector: 'app-gdo-edit-subscriber-contact-information',
  templateUrl: './gdo-edit-subscriber-contact-information.component.html',
  styleUrls: ['./gdo-edit-subscriber-contact-information.component.scss'],
  standalone: false
})

export class GdoEditSubscriberContactInformationComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  data!: IAcctDetail;
  editContactInfo!: UntypedFormGroup;
  isWebView: boolean = false;
  phoneTypes = [{ value: 'Mobile' }, { value: 'Landline' }];
  preferredLanguage = [
    { displayValue: 'English', value: 'System_US_English_locale' },
    { displayValue: 'French', value: 'fr_CAN' },
  ];
  countries = [
    { displayValue: 'United States', value: 'US' },
    { displayValue: 'Canada', value: 'CA' },
  ];

  stateProvDropdown: any;
  allowChangeVehicle: any = null;
  validators = [this.appService.nameValidation,
  this.appService.phoneNoValidation,
  this.appService.zipCodeValidation,
  this.appService.cityAddressValidation]
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private appService: AppService
  ) { }

  ngOnInit(): void {
    this.data = this.appService.getAccDetails();
    this.initEditForm();
    this.isWebView = this.appService.getWebviewCurrentStatus();
  }

  initEditForm() {

    this.editContactInfo = new UntypedFormGroup({
      first_name: new UntypedFormControl(this.data?.firstName, Validators.required),
      last_name: new UntypedFormControl(this.data?.lastName, Validators.required),
      phone: new UntypedFormControl(convertToUsFormat(this.data?.phone), Validators.required),
      address1: new UntypedFormControl(this.data?.address1, Validators.required),
      address2: new UntypedFormControl(this.data?.address2),
      cell_phone: new UntypedFormControl(convertToUsFormat(this.data?.cellPhone)),
      city: new UntypedFormControl(this.data?.city, Validators.required),
      country_cd: new UntypedFormControl(this.data?.countryCode),
      state_prov: new UntypedFormControl(this.data?.stateProv),
      mobile_prov: new UntypedFormControl(''),
      business_name: new UntypedFormControl(this.data.companyName),
      email: new UntypedFormControl({ value: this.data?.email, disabled: true }),
      locale_name: new UntypedFormControl(this.data?.acctLocaleName),
      postal_cd: new UntypedFormControl(this.data?.postalCode, Validators.required),
    },
      this.validators);
    this.onCountryChange(null);
  }

  onCountryChange(event: any) {
    const selectedCountry = this.editContactInfo?.value?.country_cd;
    if (selectedCountry && selectedCountry === 'US') {
      this.stateProvDropdown = Us_State_prov;
    } else if (selectedCountry && selectedCountry === 'CA') {
      this.stateProvDropdown = Ca_State_prov;
    }
  }
  tildeConversion(value: string) {
    if (value && value.length > 0) {
      return value;
    } else return '~';
  }

  onSaveClick() {
    if (this.editContactInfo.valid) {
      const acctDetails = this.appService.getAccDetails();
      let billing_group_no = acctDetails.billingGroupsInfo && acctDetails.billingGroupsInfo.length > 0 ? acctDetails.billingGroupsInfo[0].billingGroupNo : null;
      let bill_contact_no = acctDetails.paymentMethodsInfo && acctDetails.paymentMethodsInfo.length > 0 ? acctDetails.paymentMethodsInfo[0].billContactNo : null;
      let contacts_list = [];
      let composeObject: any;

      let reqObj;
      let data = Object.assign(this.editContactInfo.value);
      // data.phone = convertToNumericDigits(data.phone);
      // data.cell_phone = convertToNumericDigits(data.cell_phone);
      // data.address2 = this.tildeConversion(data.address2);
      // data.city = this.tildeConversion(data.city);
      // data.companyName = this.tildeConversion(data.companyName);
      let contacts_list_obj: any = {
        addr_contact_idx: 1,
        addr_first_name: data.first_name,
        addr_last_name: data.last_name,
        addr_phone: data.phone,
        addr_cell_phone: data.cell_phone,
        addr_address1: data.address1,
        addr_address2: data.address2,
        addr_city: data.city,
        addr_country: data.country_cd,
        addr_state_prov: data.state_prov,
        addr_email: acctDetails.email,
        addr_postal_cd: data.postal_cd,
        addr_company_name: data.business_name
      };
      composeObject = {
        locale_name: data.locale_name,
        acct_contact_idx: 1,
        billing_groups_array: [{
          stmt_contact_idx: 1, //hardcode as discussed with wajid
          billing_group_no,
        }],
        // payment_methods_array: [{
        //   bill_contact_idx: 1,//hardcode as discussed with wajid
        //   // bill_contact_no: bill_contact_no,
        //   "payment_method_no": 1, // need to ask honda to include it 
        // }],
        contacts_list: [
          contacts_list_obj
        ]
      }

      reqObj = transformIntoApiCallObj(
        composeObject,
        'update_acct_complete_m');
      

      this.appService.AriaPassThroughConnect(reqObj).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
        if (res && res.error_msg === 'OK' && res.error_code === 0) {
          let statusData: StatusDTO = {
            title: 'Contact Updated',
            details: 'Contact Information has been updated',
            stepSuccessful: true,
          };

          let ref = this.dialog.open(GdoStepCompletionStatusComponent, {
            data: statusData,
          });

          ref.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result) => {
            this.router.navigate(['/gdo-product'], { replaceUrl: true });
          });
        } else {
          let statusData: StatusDTO = {
            title: 'Error occured',
            details: res.error_msg,
            stepSuccessful: false,
          };

          let ref = this.dialog.open(GdoStepCompletionStatusComponent, {
            data: statusData,
          });
        }
      });
    }
  }

  onBackClick() {
    this.router.navigate(['/gdo-product'], { replaceUrl: true });
  }
  static nameValidation: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    const firstNameControl = control.get('first_name');
    const lastNameControl = control.get('last_name');
    if (!firstNameControl || !lastNameControl) return null;
    const fName = firstNameControl.value;
    const lName = lastNameControl.value;
    const alphasRegex = /^[a-zA-Z]+$/;
    let fNameCorrect = true;
    let lNameCorrect = true;


    if (fName && fName !== "") {
      if (fName.match(alphasRegex)) {
        fNameCorrect = true;
      }
      else {
        fNameCorrect = false;
      }
    }
    if (lName && lName !== "") {
      if (lName.match(alphasRegex)) {
        lNameCorrect = true;
      }
      else {
        lNameCorrect = false;
      }
    }

    if (fNameCorrect == false) {
      firstNameControl.setErrors({ firstNotAlpha: true });
    }
    if (lNameCorrect == false) {
      lastNameControl.setErrors({ lastNotAlpha: true });
    }
    return null;
  }

  static phoneNoValidation: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const primaryPhoneControl = control.get('phone');
    const secondaryPhoneControl = control.get('cell_phone');
    if (!primaryPhoneControl || !secondaryPhoneControl) return null;
    const primaryPhone = primaryPhoneControl.value;
    const secondaryPhone = secondaryPhoneControl.value;
    var numRegex = /^[0-9]*$/;
    var USPhoneFormat = /(\d{0,3})(\d{0,3})(\d{0,4})/;
    var primaryCorrect: boolean;
    var minLength: boolean = true;
    var secMinLength: boolean = true;
    var secondaryCorrect: boolean;

    if (primaryPhone && primaryPhone !== "") {
      if (primaryPhone.match(numRegex) || primaryPhone.match(USPhoneFormat)) {
        if (primaryPhone.length < 14) {
          minLength = false;
        }
        else {
          minLength = true;
        }
      }
      if (minLength == false) {
        primaryPhoneControl.setErrors({ notMinLength: true });
      }
      else {
        primaryPhoneControl.setErrors(null);
      }
    }
    if (secondaryPhone && secondaryPhone !== "") {
      if (secondaryPhone.match(numRegex) || secondaryPhone.match(USPhoneFormat)) {
        if (secondaryPhone.length < 14) {
          secMinLength = false;
        }
        else {
          secMinLength = true;
        }
      }
      if (secMinLength == false) {
        secondaryPhoneControl.setErrors({ notSecMinLength: true });
      }
      else {
        secondaryPhoneControl.setErrors(null);
      }
    }

    // removed error check for special characters
    // if (primaryCorrect == false) {
    //   control.get('phone').setErrors({ primaryNotValid: true });
    // }

    // removed error check for special characters
    // if (secondaryCorrect == false) {
    //   control.get('cell_phone').setErrors({ secondaryNotValid: false });
    // }
    else {
      secondaryPhoneControl.markAsPristine();
      secondaryPhoneControl.markAsUntouched();
    }
    return null;
  }
  static zipCodeValidation: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    const postalCodeControl = control.get('postal_cd');
    const countryControl = control.get('country_cd');
    if (!postalCodeControl || !countryControl) return null;
    const zipCode = postalCodeControl.value;
    const country = countryControl.value;

    var zipUSRegex = /^\d{5}(-\d{4})?$/;
    var zipCADRegex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
    let zipUSCorrect = true;
    let zipCADCorrect = true;

    if (country != null) {

      if (country == 'US') {
        if (zipCode && zipCode !== "") {
          if (zipCode.match(zipUSRegex)) {
            zipUSCorrect = true;
          }
          else {
            zipUSCorrect = false;
          }
        }
        if (zipUSCorrect == false) {
          postalCodeControl.setErrors({ zipUSNotValid: true });
        } else {
          postalCodeControl.setErrors(null);
        }
      }
      else if (country == 'CA') {
        if (zipCode && zipCode !== "") {
          if (zipCode.match(zipCADRegex)) {
            zipCADCorrect = true;
          }
          else {
            zipCADCorrect = false;
          }
        }
        if (zipCADCorrect == false) {
          postalCodeControl.setErrors({ zipCADNotValid: true });
        } else {
          postalCodeControl.setErrors(null);
        }

      }
    }
    return null;
  }
  static cityAddressValidation: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const addressControl = control.get('address1');
    const cityControl = control.get('city');
    if (!addressControl || !cityControl) return null;
    const address = addressControl.value;
    const city = cityControl.value;
    let addressCorrect = true;
    let cityCorrect = true;
    if (address && address != "") {
      if (address.trim().length === 0) {
        addressCorrect = false;
      }
      else {
        addressCorrect = true;
      }
      if (addressCorrect == false) {
        addressControl.setErrors({ addressOnlySpace: true });
      } else {
        addressControl.setErrors(null);
      }
    }
    if (city && city != "") {
      if (city.trim().length === 0) {
        cityCorrect = false;
      }
      else {
        cityCorrect = true;
      }
      if (cityCorrect == false) {
        cityControl.setErrors({ cityOnlySpace: true });
      } else {
        cityControl.setErrors(null);
      }
    }
    return null;
  }

  trackByNgForItem(index: number, item: any): string | number {
    return item?.value ?? item?.payment_method_no ?? item?.paymentMethodNo ?? item?.couponCode ?? item?.id ?? item?.title ?? item?.displayValue ?? item ?? index;
  }
}
function convertToUsFormat(phone: string | undefined): string | null {
  if (phone) {
    phone = phone.replace(/[^\d]/g, "");
    return phone.replace(/(\d{0,3})(\d{0,3})(\d{0,4})/, "($1) $2-$3");
  }
  else {
    return null;
  }
}

function convertToNumericDigits(phone: string): any {
  if (phone && phone.length > 0) {
    phone = phone.replace(/[() -]/g, "");
    return phone;
  }
  else {
    return '~';
  }
}
